import React from 'react';
import { useAuth } from  '../../contexts/auth';

import { createStore } from 'devextreme-aspnet-data';
import { formatNumber } from 'devextreme/localization';
import DataGrid, {
  Format,
  Column,
  Button,
  Pager,
  Paging,
  //FilterRow,
  HeaderFilter,
  Lookup,
  Popup,
  Form,
  Editing,
  Selection,
  Summary,
  Export,
  TotalItem,
  SearchPanel,
  Toolbar,
  Item
} from 'devextreme-react/data-grid';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

export default function AccountingTab(props) {

    const { user } = useAuth(); 
    const projectId = props.projectId
    const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Contabilita';

   
    const filterPayload = { 
        commessa: projectId
    };

    const remoteDataSource = createStore({
        key: 'id',
        loadUrl: serviceUrl2 + '/FindAnaliticaDettaglio',
      
        onBeforeSend: (method, ajaxOptions) => {
          if (method === "load" ) {           
              var payload = ajaxOptions.data;
              payload.values = JSON.stringify(filterPayload);
              ajaxOptions.data = payload;          
          }  
          ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
         ;
        }  
    });

    function onExporting(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Contabilità');
    
        exportDataGrid({
          component: e.component,
          worksheet,
          autoFilterEnabled: true,
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Contabilità.xlsx');
          });
        });
        e.cancel = true;
    }

    function customizeData(data) {
        return `${formatNumber(data.value, '#,###,##0.00')}`;
    }

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <DataGrid
                        dataSource={remoteDataSource}
                        focusedRowEnabled={true}
                        showBorders={true}
                        onExporting={onExporting}
                        //onCellPrepared={onCellPreparedDue}
                        //onSelectionChanged={onRowSelectionChanged}
                        //onExporting={onExporting}
                        //onToolbarPreparing = {onToolbarPreparing}
                        //ref={ref => dueSupplierDataGridRef = ref}
                    >

                        <SearchPanel visible={true} width={240} placeholder="Cerca..." />
                        <HeaderFilter visible={true} />
                        <Selection mode="single" />

                        <Column dataField="id" caption="#" visible={true} width={80} />
                        <Column dataField="dataPagamento" caption="Data" dataType="date" format= {'dd/MM/yyyy'} visible={true}/>
                        <Column dataField="dataRiferimento" dataType="date" format= {'dd/MM/yyyy'} visible={false} width={120}/>
                        <Column dataField="descrizione"  visible={true}/>
                        <Column dataField="tipoMovimentoId" caption="Tipo" visible={false}/>
                        <Column dataField="categoria"  visible={true}/>
                    
                        <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} visible={false}/>
                       
                        <Column dataField="dare" visible={true} allowEditing={false} caption="Dare">
                            <Format type="fixedPoint" precision={2} />
                        </Column>
                        <Column dataField="avere" visible={true} allowEditing={false} caption="Avere">
                            <Format type="fixedPoint" precision={2} />
                        </Column>

                        <Summary>
                            <TotalItem
                                column="dataRiferimento"
                                summaryType="max"
                                displayFormat="Totali: "
                                showInGroupFooter={true} />
                            <TotalItem
                                column="dare"
                                summaryType="sum"
                                displayFormat="{0}"
                                customizeText={customizeData}
                                showInGroupFooter={true} />
                            <TotalItem
                                column="avere"
                                summaryType="sum"
                                displayFormat="{0}"
                                customizeText={customizeData}
                                showInGroupFooter={true} />
                        </Summary>
                        <Export enabled={true} allowExportSelectedData={false} />
                    </DataGrid>
        
                </div>
            </div>
        </React.Fragment>
    )
};